module.exports = __webpack_public_path__ + "static/img_9730-3cf22bc6051f7d4698eb2d1d1335191d.webp";